module.exports = __webpack_public_path__ + "static/media/ml.07e6149e.svg";